import { useState, useEffect } from "react";
import { loadCityList } from "../services/locationService";

const useLocations = (editShiftAssignmentID) => {
    const [locations, setLocations] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [selectedLocationID, setSelectedLocationID] = useState(null);
    const [isLocationDataLoaded, setIsLocationDataLoaded] = useState(false);

    // Fetch department data
    const fetchLocations = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid") };

        try {
            const data = await loadCityList(para);
            if (data && data.length > 0) {
                setLocations(data);
                const initialDepartment = data.find((dept) => dept.id === selectedID);
                // const initialDepartment = data.find((dept) => dept.id === selectedID) || data[0];
                if (initialDepartment?.length > 0 ) {
                    setSelectedLocation(initialDepartment);
                    setSelectedLocationID(initialDepartment.id);
                    setIsLocationDataLoaded(true);
                }

            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isLocationDataLoaded && editShiftAssignmentID === 0) {
            fetchLocations();
        }
    }, [isLocationDataLoaded, editShiftAssignmentID]);

    // Function to load department based on selected ID
    const loadLocationByID = async (selectedID) => {
        await fetchLocations(selectedID);
    };

    return {
        locations,
        selectedLocation,
        selectedLocationID,
        setSelectedLocation,
        setSelectedLocationID,
        loadLocationByID,
    };
};

export default useLocations;
